module.exports = __webpack_public_path__ + "static/media/human3.f4a562c0.png";